import AgentBuilder from '../components/AgentBuilder';

const CreateAgent = () => {
  return <AgentBuilder />;
};

export default CreateAgent;
